import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/read/$novelId')({
  component: () => <Outlet />,
});
